import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/stats/base/dists/cosine/cdf';
import __var_2__ from '@stdlib/stats/base/dists/cosine/ctor';
import __var_3__ from '@stdlib/stats/base/dists/cosine/kurtosis';
import __var_4__ from '@stdlib/stats/base/dists/cosine/logcdf';
import __var_5__ from '@stdlib/stats/base/dists/cosine/logpdf';
import __var_6__ from '@stdlib/stats/base/dists/cosine/mean';
import __var_7__ from '@stdlib/stats/base/dists/cosine/median';
import __var_8__ from '@stdlib/stats/base/dists/cosine/mgf';
import __var_9__ from '@stdlib/stats/base/dists/cosine/mode';
import __var_10__ from '@stdlib/stats/base/dists/cosine/pdf';
import __var_11__ from '@stdlib/stats/base/dists/cosine/quantile';
import __var_12__ from '@stdlib/stats/base/dists/cosine/skewness';
import __var_13__ from '@stdlib/stats/base/dists/cosine/stdev';
import __var_14__ from '@stdlib/stats/base/dists/cosine/variance';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace.
*
* @namespace cosine
*/
var cosine = {};

/**
* @name cdf
* @memberof cosine
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/cosine/cdf}
*/
setReadOnly( cosine, 'cdf', __var_1__);

/**
* @name Cosine
* @memberof cosine
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/cosine/ctor}
*/
setReadOnly( cosine, 'Cosine', __var_2__);

/**
* @name kurtosis
* @memberof cosine
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/cosine/kurtosis}
*/
setReadOnly( cosine, 'kurtosis', __var_3__);

/**
* @name logcdf
* @memberof cosine
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/cosine/logcdf}
*/
setReadOnly( cosine, 'logcdf', __var_4__);

/**
* @name logpdf
* @memberof cosine
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/cosine/logpdf}
*/
setReadOnly( cosine, 'logpdf', __var_5__);

/**
* @name mean
* @memberof cosine
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/cosine/mean}
*/
setReadOnly( cosine, 'mean', __var_6__);

/**
* @name median
* @memberof cosine
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/cosine/median}
*/
setReadOnly( cosine, 'median', __var_7__);

/**
* @name mgf
* @memberof cosine
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/cosine/mgf}
*/
setReadOnly( cosine, 'mgf', __var_8__);

/**
* @name mode
* @memberof cosine
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/cosine/mode}
*/
setReadOnly( cosine, 'mode', __var_9__);

/**
* @name pdf
* @memberof cosine
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/cosine/pdf}
*/
setReadOnly( cosine, 'pdf', __var_10__);

/**
* @name quantile
* @memberof cosine
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/cosine/quantile}
*/
setReadOnly( cosine, 'quantile', __var_11__);

/**
* @name skewness
* @memberof cosine
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/cosine/skewness}
*/
setReadOnly( cosine, 'skewness', __var_12__);

/**
* @name stdev
* @memberof cosine
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/cosine/stdev}
*/
setReadOnly( cosine, 'stdev', __var_13__);

/**
* @name variance
* @memberof cosine
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/cosine/variance}
*/
setReadOnly( cosine, 'variance', __var_14__);


// EXPORTS //
export default cosine;

export { __var_1__ as cdf, __var_2__ as Cosine, __var_3__ as kurtosis, __var_4__ as logcdf, __var_5__ as logpdf, __var_6__ as mean, __var_7__ as median, __var_8__ as mgf, __var_9__ as mode, __var_10__ as pdf, __var_11__ as quantile, __var_12__ as skewness, __var_13__ as stdev, __var_14__ as variance};